import React from 'react';
import { TableStc } from './Table.stc';

function Table({ data, type }) {
    if (!data) {
        return null;
    }

    return (
        <TableStc Type={type}>
            <thead>
                <tr>
                    {data.head.map((item, hi) => (
                        <th key={hi}>{item}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.body.map((row, ri) => (
                    <tr key={ri}>
                        {row.map((td, tdi) => (
                            <td key={tdi}>{td}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </TableStc>
    );
}

export default Table;
